/* eslint-disable */
require('./admin')
require('./alert-circle')
require('./alert-triangle')
require('./allianz')
require('./arrow_dropdown')
require('./arrow_right')
require('./calendar')
require('./close-form')
require('./close')
require('./coins')
require('./dashboard')
require('./delete')
require('./dossier')
require('./edit')
require('./fence')
require('./filePrice')
require('./globe')
require('./house')
require('./ico-ajouter')
require('./ico-bath-2')
require('./ico-bath')
require('./ico-bedroom')
require('./ico-ceiling')
require('./ico-chevron')
require('./ico-cp')
require('./ico-date')
require('./ico-dinning')
require('./ico-documents')
require('./ico-dommages')
require('./ico-donnes-du-dossier')
require('./ico-door')
require('./ico-dossiers')
require('./ico-fence')
require('./ico-floor')
require('./ico-garage')
require('./ico-groupe-garantie')
require('./ico-hall')
require('./ico-inscrire-dossier')
require('./ico-kitchen')
require('./ico-lang')
require('./ico-leak')
require('./ico-logo-gen')
require('./ico-logo-multiasistencia')
require('./ico-materialtype')
require('./ico-mobilier')
require('./ico-moins')
require('./ico-montant')
require('./ico-nav')
require('./ico-notification-ok_Mesa de trabajo 1')
require('./ico-notification')
require('./ico-numero-police')
require('./ico-others-2')
require('./ico-others')
require('./ico-photos')
require('./ico-pieces-touchees')
require('./ico-pipe')
require('./ico-plus')
require('./ico-question')
require('./ico-reference-dossier')
require('./ico-regarde')
require('./ico-roof')
require('./ico-siren')
require('./ico-suprimmer')
require('./ico-surface')
require('./ico-toilet')
require('./ico-view-modes')
require('./ico-wall')
require('./ico-washing-machine')
require('./ico-window')
require('./Info')
require('./ko')
require('./logoGen')
require('./logoMa')
require('./logout')
require('./mobiliere')
require('./ok')
require('./pencil-edit')
require('./phone')
require('./rangeLabel')
require('./recherche')
require('./refresh')
require('./search-mobilier')
require('./search')
require('./surface')
require('./tools')
require('./trash')
require('./tutorials')
require('./warrantyBaremeGenTech')
require('./warrantyBaremeGenTechDE')
require('./warrantyBaremeRenoEnerg')
require('./warrantyDEImmo')
require('./warrantyDEImmo2')
require('./warrantyDEImmoSimple')
require('./warrantyDEImmoSimpleNoPieces')
require('./warrantyFurniture')
require('./warrantyGeneric')
require('./warrantyGlass')
require('./warrantyImmoGenE2E')
require('./warrantyImmoGenImmo')
require('./warrantyStorm')
require('./warrantyTheft')
require('./warrantyWallBox')
require('./warrantyWater')
require('./x')
require('./Yellow')
require('./zoom-in')
require('./zoom-out')
